import type { CommitmentVersion } from '@festina/life-general-types/life'
import type { Optional } from '@festina-life/core'
import { useTranslateEnum } from '@festina-life/ui/hooks'

import { useAvailableComponents } from '../../../hooks/useAvailableComponents'
import { useHook } from '../../../lenteHooks'
import { findMemberIcon } from '../../memberInfo/utilities'

export const MemberIconFromCommitmentVersion = () => {
  const translateEnum = useTranslateEnum()
  const { isUsingLife } = useAvailableComponents()
  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const { data: commitmentVersion }: { data: Optional<CommitmentVersion> } =
    useHook('fetchers.life.useFetchCommitmentVersionLatestNoSuspense')(
      {
        ownerId,
        tenantId,
      },
      {
        enabled: !!isUsingLife,
      },
    )

  const gender = commitmentVersion?.insured?.gender

  return (
    <img
      src={findMemberIcon(gender)}
      title={translateEnum('life.enum.Gender', gender)}
      className="size-14"
    />
  )
}
